<template>
  <div class="flex flex-row h-full">
    <div class="w-[60%] macros-canvas">
      <macro-nodes
        v-model="macro.actions"
        :files="files"
        @addNewNode="appendNode"
        @deleteNode="deleteNode"
        @resetAction="resetNode"
      />
    </div>
    <div class="w-[34%]">
      <macro-properties
        :macro-name="macro.name"
        :macro-visibility="macro.visibility"
        :is-submitting="isSubmitting"
        @update:name="updateName"
        @update:visibility="updateVisibility"
        @submit="submit"
        @input="GetInput"
      />
    </div>
  </div>
</template>

<script>
import MacroNodes from './MacroNodes';
import MacroProperties from './MacroProperties';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  components: {
    MacroNodes,
    MacroProperties,
  },
  provide() {
    return {
      $v: this.$v,
    };
  },
  props: {
    macroData: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      macro: this.macroData,
    };
  },
  computed: {
    files() {
      if (this.macro && this.macro.files) return this.macro.files;
      return [];
    },
  },
  watch: {
    $route: {
      handler() {
        this.resetValidation();
      },
      immediate: true,
    },
    macroData: {
      handler() {
        this.macro = this.macroData;
      },
      immediate: true,
    },
  },
  validations: {
    macro: {
      name: {
        required,
      },
      visibility: {
        required,
      },
      actions: {
        required,
        $each: {
          action_params: {
            required: requiredIf(prop => {
              if (prop.action_name === 'send_email_to_team') return true;
              if (prop.action_name === 'send_api_webhook') {
                return prop.action_params && prop.action_params.url && prop.action_params.url.length > 0;
              }
              if (prop.action_name === 'send_kivo_notification') {
                return false;
              }
              if (prop.action_name === 'set_reminder') {
                return prop.action_params && prop.action_params.note && prop.action_params.note.length > 0;
              }
              return !(
                prop.action_name === 'mute_conversation' ||
                prop.action_name === 'snooze_conversation' ||
                prop.action_name === 'resolve_conversation' ||
                prop.action_name === 'remove_assigned_team'
              );
            }),
            kivoWebhookParamsValid(value, prop) {
              if (prop.action_name !== 'send_kivo_notification') return true;
              const params = value || {};
              const url = typeof params.url === 'string' ? params.url.trim() : '';
              const text = typeof params.text === 'string' ? params.text.trim() : '';
              return url.length > 0 && text.length > 0;
            },
          },
        },
      },
    },
  },
  methods: {
    GetInput(value){
      console.log(value);
    },
    updateName(value) {
      this.macro.name = value;
    },
    updateVisibility(value) {
      this.macro.visibility = value;
    },
    appendNode() {
      this.macro.actions.push({
        action_name: 'assign_team',
        action_params: [],
      });
    },
    getDefaultActionParams(actionName) {
      if (actionName === 'send_api_webhook') {
        return {
          url: '',
          method: 'POST',
          headers: '',
          payload: '',
          auto_execute: false,
        };
      }
      if (actionName === 'send_kivo_notification') {
        return { url: '', text: '' };
      }
      if (actionName === 'set_reminder') {
        return {
          note: '',
        };
      }
      return [];
    },
    deleteNode(index) {
      this.macro.actions.splice(index, 1);
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.$emit('submit', this.macro);
    },
    resetNode(index) {
      this.$v.macro.actions.$each[index].$reset();
      const actionName = this.macro.actions[index].action_name;
      if (actionName === 'send_api_webhook') {
        this.macro.actions[index].action_params = {
          url: '',
          method: 'POST',
          headers: '',
          payload: '',
          auto_execute: false,
        };
      } else if (actionName === 'send_kivo_notification') {
        this.macro.actions[index].action_params = { url: '', text: '' };
      } else if (actionName === 'set_reminder') {
        this.macro.actions[index].action_params = {
          note: '',
        };
      } else {
        this.macro.actions[index].action_params = [];
      }
    },
    resetValidation() {
      this.$v.$reset();
    },
  },
};
</script>

<style scoped>
@tailwind components;
@layer components {
  .macro-gradient-radial {
    background-image: radial-gradient(#ebf0f5 1.2px, transparent 0);
  }
  .macro-dark-gradient-radial {
    background-image: radial-gradient(#293f51 1.2px, transparent 0);
  }
  .macro-gradient-radial-size {
    background-size: 1rem 1rem;
  }
}
.macros-canvas {
  @apply macro-gradient-radial dark:macro-dark-gradient-radial macro-gradient-radial-size h-full max-h-full py-4 px-12 overflow-y-auto;
}
</style>
